module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_8011.08cd6b9d.png";